export default __webpack_public_path__ + "static/image-one-e14316708b6adfbe5cc19634fcb9413e.png";